/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1WebimFieldsModel } from '../../entities/v1/WebimFieldsModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1WebimFieldsModelSchema = z.object({
  email: z.string(),
  id: z.string(),
  info: z.string(),
  name: z.string(),
  phone: z.string(),
  profile_url: z.string(),
}) as unknown as ToZod<V1WebimFieldsModel>